import theme from '@/style';
import {TabView} from '@rneui/themed';
import React from 'react';
import Racecar from './racecar/racecar';
import ScratchResult from './scratch/scratch';
import KeralaResult from './kerala/kerala';
import DigitResult from './digit/digit';
import ColorResult from './color/color';
import DiceResult from './dice/dice';
import MatkaResult from './matka/matka';
import TabBar from '../transaction/components/transaction-tabBar';
import {View} from 'react-native';
import {packageId} from '@/config';
import {MatkaTypeItem} from './result.type';
import QuickDigitResult from './quick-digit/quick-digit';
import StateLottery from './state-lottery/state-lottery';

const ROUTERS = [
  {
    type: 'scratch',
    typeName: 'Scratch Off',
    component: ScratchResult,
    hide: [],
  },
  {
    type: 'kerala',
    typeName: 'Kerala',
    component: KeralaResult,
    hide: [5, 6, 8],
  },
  {
    type: 'digit',
    typeName: '3 Digits',
    component: DigitResult,
    hide: [5, 6],
  },
  {
    type: 'quickDigit',
    typeName: 'Quick 3 Digits',
    component: QuickDigitResult,
    hide: [5, 6],
  },
  {
    type: 'color',
    typeName: 'Color',
    component: ColorResult,
    hide: [],
  },
  {
    type: 'dice',
    typeName: 'Dice',
    component: DiceResult,
    hide: [],
  },
  {
    type: 'matka',
    typeName: 'Matka',
    component: MatkaResult,
    hide: [5, 6, 8],
  },
  {
    type: 'racecar',
    typeName: 'Quick Race',
    component: Racecar,
    hide: [],
  },
  {
    type: 'state-lottery',
    typeName: 'State Lottery',
    component: StateLottery,
    hide: [8],
  },
];

const Lottery = ({
  currentIndex = 0,
  onChange,
  selectType,
  matkaType = [],
  digitTypes,
}: {
  currentIndex?: number;
  selectType?: string;
  onChange: (v: number) => void;
  matkaType?: MatkaTypeItem[];
  digitTypes?: {label: string; value: number}[];
}) => {
  const targetRoutes = React.useMemo(() => {
    return ROUTERS.filter(item => !item.hide.includes(packageId));
  }, []);
  return (
    <>
      <View style={[theme.padding.tbs, theme.background.white]}>
        <TabBar
          value={currentIndex}
          routers={targetRoutes}
          onChange={onChange}
        />
      </View>
      <TabView value={currentIndex} onChange={onChange}>
        {targetRoutes.map((item, index) => {
          return (
            <TabView.Item style={[theme.fill.fillW]}>
              <item.component
                isActive={currentIndex === index}
                lotteryType={selectType}
                digitTypes={digitTypes}
                matkaType={matkaType}></item.component>
            </TabView.Item>
          );
        })}
      </TabView>
    </>
  );
};

export default Lottery;
